// ─── Supabase singleton + boot-time wiring into the lead store ───────────────
// Loaded once from index.js. If env vars are missing the calculator silently
// falls back to localStorage-only mode (handled inside leadStore).

import { createClient } from "@supabase/supabase-js";
import { setSupabaseClient } from "./leadStore";

const URL = process.env.REACT_APP_SUPABASE_URL;
const KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

let _client = null;

export function getSupabase() {
  if (_client) return _client;
  if (!URL || !KEY) {
    // eslint-disable-next-line no-console
    console.info("[supabase] env vars not set — running in local-only mode");
    return null;
  }
  _client = createClient(URL, KEY, {
    auth: { persistSession: false, autoRefreshToken: false },
  });
  return _client;
}

// Wire it up on module import so the calculator can use it transparently.
const client = getSupabase();
if (client) {
  setSupabaseClient(client);
  // eslint-disable-next-line no-console
  console.info("[supabase] client wired into leadStore");
}

export default getSupabase;
